import { render } from "./ManagerViewOrg.vue?vue&type=template&id=6e3f92a2"
import script from "./ManagerViewOrg.vue?vue&type=script&lang=js"
export * from "./ManagerViewOrg.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__